<script>
    import {getObj, getObjects, saveObj, deleteObj, getFields} from '../lib/data.js'
    import {notifier} from '@beyonk/svelte-notifications';
    import {replace} from 'svelte-spa-router';

    import Form from '../Forms/Form.svelte';

    export let params = {
        id: null
    }

    let errors = [];
    let fields = getFields("users");

    let user;
    let userList = getObjects("users")

    $: getUser(params.id)

    async function saveUser() {
        try {
            user = await saveObj("users", user)
            notifier.success("User Saved")
            userList = getObjects("users")
        } catch (err) {
            // special case for password
            if (err['_schema']) {
                err['pwd'] = err['_schema']
            }
            errors = err;
        }
    }

    async function deleteUser() {
        await deleteObj("users", user);
        notifier.success("User Deleted")
        params.id = null;
        userList = getObjects("users")
    }

    async function getUser(id) {
        try {
            user = await getObj("users", id);
        } catch (error) {
            params.id = null;
            notifier.danger("User Not Found")
            //replace('/auth/users')
        }
    }
</script>

<div class="columns">
    <aside class="menu column is-2">
        <p class="menu-label">
            Current Users
        </p>
        {#await userList}
            Loading...
        {:then users}
        <ul class="menu-list">
            <li>
                <ul>
                    {#each users as user}
                        <li><a href="#/auth/users/{user.id}">{user.name}</a></li>
                    {/each}
                </ul>
                <a href="#/auth/users/">Add New User</a>
            </li>
        </ul>
        {/await}
    </aside>

    {#if !user}
    Loading...
    {:else}
    <div class="column">
        <span class="title">{#if user.id}Edit{:else}Add{/if} User</span>
        <hr>
        <Form {fields} on:submit={saveUser} on:delete={deleteUser} bind:data={user} {errors} />
    </div>
    {/if}
</div>